/**
 * Связанные доки:
 * - docs/living/okdoc/OKDOC_SCENARIOS_FOUNDATION.md
 * - docs/living/taxonomy/TEMPLATE_OKDOC_TAXONOMY_ARCHITECTURE.md
 * Если меняется taxonomy CTA / interaction intent, обновляйте и код, и доки.
 */
import type { OkdocCTAActionKind, OkdocInteractionIntent } from '@/features/okdoc/types';

export const OKDOC_CTA_ACTION_LABELS: Record<OkdocCTAActionKind, string> = {
  open_url: 'Открыть ссылку',
  leave_review: 'Оставить отзыв',
  read_recommendations: 'Открыть рекомендации',
  open_personal_account: 'Открыть личный кабинет',
  contact_channel: 'Открыть канал связи',
  book_now: 'Записаться',
  claim_offer: 'Получить оффер',
  choose_gift: 'Выбрать подарок',
  call_clinic: 'Позвонить в клинику',
};

export const OKDOC_INTERACTION_INTENT_LABELS: Record<OkdocInteractionIntent, string> = {
  confirmation: 'Подтверждение',
  cancellation: 'Отмена',
  reschedule: 'Перенос',
  feedback: 'Ответ по ОС',
  feedback_engagement: 'Переход к отзыву',
  care_followup: 'После приёма',
  marketing_engagement: 'Маркетинговое вовлечение',
  account_engagement: 'Открытие ЛК',
  contact_navigation: 'Переход в канал связи',
  offer_claim: 'Получение оффера',
  gift_choice: 'Выбор подарка',
  booking_intent: 'Намерение записаться',
  external_navigation: 'Внешний переход',
};

export const OKDOC_CTA_ACTION_OPTIONS = Object.entries(OKDOC_CTA_ACTION_LABELS).map(([value, label]) => ({ value, label }));
export const OKDOC_INTERACTION_INTENT_OPTIONS = Object.entries(OKDOC_INTERACTION_INTENT_LABELS).map(([value, label]) => ({ value, label }));

export function getOkdocCTAActionLabel(value?: string): string {
  if (!value) return '';
  return OKDOC_CTA_ACTION_LABELS[value as OkdocCTAActionKind] || value;
}

export function getOkdocInteractionIntentLabel(value?: string): string {
  if (!value) return '';
  return OKDOC_INTERACTION_INTENT_LABELS[value as OkdocInteractionIntent] || value;
}
